import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { useDebounce } from 'uikit';

import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerIsUniquePriceListMtrRowKeyGql } from '../workOrderQueries';

const requestId = 'uerIsUniquePriceListMtrRowKey';

interface IUseIsUniquePriceListMtrRowKey {
    contractId: number;
    mtrRowId: number | null;
    key: string;
    isDirtyCodeValue: boolean;
}

export const useIsUniquePriceListMtrRowKey = ({
    contractId,
    mtrRowId,
    key,
    isDirtyCodeValue,
}: IUseIsUniquePriceListMtrRowKey) => {
    const dispatch = useDispatch();

    const [data, status, err, request] = useRequest({
        requestId,
        query: uerIsUniquePriceListMtrRowKeyGql,
        withEffect: false,
    });

    const variables = useMemo(
        () => (!!contractId && key?.length ? { contractId, mtrRowId, key } : undefined),
        [contractId, key, mtrRowId],
    );

    const debounceRequest = useDebounce(() => {
        if (key && isDirtyCodeValue) {
            dispatch(request(variables));
        }
    }, 300);

    const [uerIsUniqueContractObjectCodeReset] = useResetStoreData({ requestId });

    useEffect(() => {
        if (key?.length) {
            debounceRequest();
        }
    }, [debounceRequest, key?.length]);

    useEffect(
        () => () => {
            uerIsUniqueContractObjectCodeReset(undefined);
        },
        [uerIsUniqueContractObjectCodeReset],
    );

    return {
        result: data?.uerIsUniquePriceListMtrRowKey?.result ?? true,
        status,
        err,
    };
};
